import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from '@commoncore/services/logger.service';


export interface ExceptionCatchService {
    catchException(error);
    handleError(error);
}

@Injectable()
export class ExceptionHandler implements ErrorHandler {
    logger: LoggerService;
    constructor() {
        this.logger= new LoggerService();
    }

    catchException(error) {
        const date = new Date().toISOString();
            if(error==undefined){
                this.logger.error(date,'Unknown error!');
            }else if (error instanceof HttpErrorResponse) {
                this.logger.error(date, 'There was an HTTP error.', error.message, 'Status code:', (<HttpErrorResponse>error).status);
            } else if (error instanceof TypeError) {
                this.logger.error(date, 'There was a Type error.', error.message);
            } else if (error instanceof Error) {
                this.logger.error(date, 'There was a general error.', error.message);
            } else {
                this.logger.error(date, 'Nobody threw an Error but something happened!', error);
            }
    }

    public handleError(error: any) {
        this.catchException(error);
    }
}
